<svg-icon name="volume-up"></svg-icon>